// extracted by mini-css-extract-plugin
module.exports = {"rating":"StarRating_rating__fAI6c","star":"StarRating_star__8sOcT","editable":"StarRating_editable__L_aaQ","selected":"StarRating_selected__64bfC"};